export const SECTOR_DESCRIPTIONS = {
  'Auto':              'Leading automobile manufacturers and auto-component makers listed on NSE',
  'Capital Goods':     'Industrial machinery, engineering and infrastructure equipment companies',
  'Chemicals':         'Specialty chemical, agrochemical and petrochemical companies',
  'Consumer Durables': 'White goods, electronics and home appliance manufacturers',
  'Consumer Services': 'Hospitality, retail, education and consumer-facing service companies',
  'Energy':            'Power generation, transmission and energy sector companies',
  'FMCG':              'Fast-moving consumer goods — food, beverages, personal and home care',
  'Financial Services':'Banks, NBFCs, insurance companies and financial intermediaries',
  'IT':                'Software services, IT consulting and technology product companies',
  'Infra':             'Infrastructure developers in roads, ports, airports and utilities',
  'Media':             'Broadcasting, publishing, digital media and entertainment companies',
  'Metals':            'Steel, aluminium, copper and other metal producers and processors',
  'Pharma':            'Pharmaceutical manufacturers, API makers and drug distributors',
  'Realty':            'Real estate developers and property management companies',
  'Services':          'Logistics, staffing, facility management and business services',
  'Telecom':           'Telecom operators, tower companies and related equipment providers',
};

export const INDEX_DESCRIPTIONS = {
  'Nifty 50':              'Top 50 large-cap companies by free-float market capitalisation',
  'Nifty Next 50':         'Next 50 large-caps after Nifty 50 — ranks 51 to 100',
  'Nifty 100':             'Top 100 large-cap companies — Nifty 50 + Next 50 combined',
  'Nifty 200':             'Top 200 companies by market cap covering large and midcap segments',
  'Nifty 500':             'Broad market index covering the top 500 listed companies',
  'Nifty Midcap 50':       'Top 50 midcap companies by market capitalisation',
  'Nifty Midcap 100':      'Top 100 midcap companies by market capitalisation',
  'Nifty Midcap 150':      'Top 150 midcap companies by market capitalisation',
  'Nifty LargeMidcap 250': 'Combined index of 100 large-cap and 150 midcap stocks',
  'Nifty Smallcap 50':     'Top 50 small-cap companies by market capitalisation',
  'Nifty Smallcap 100':    'Top 100 small-cap companies by market capitalisation',
  'Nifty Smallcap 250':    'Top 250 small-cap companies by market capitalisation',
  'Nifty Microcap 250':    'Top 250 microcap companies beyond the Nifty 500 universe',
};

export const FINANCIALS_DESCRIPTIONS = {
  'Revenue':      'Total income from operations before any deductions',
  'Gross Profit': 'Revenue minus cost of goods sold',
  'Op. Profit':   'Operating profit (EBIT) — earnings before interest and taxes',
  'Net Profit':   'Bottom-line profit after all expenses, interest and taxes',
  'EPS (₹)':      'Earnings Per Share — net profit divided by total shares outstanding',
  'Total Assets': 'Everything the company owns — current + fixed + investments',
  'Total Debt':   'All borrowings: short-term loans + long-term bonds',
  'Equity':       'Shareholders\' equity — net worth after subtracting all liabilities',
  'Cash':         'Cash and liquid equivalents on hand',
  'Liabilities':  'Total obligations the company owes to creditors',
};

export const REGION_DESCRIPTIONS = {
  'Global':      'Worldwide market indices, macro news and cross-border economic events',
  'US':          'US stock indices — S&P 500, NASDAQ, Dow Jones and American market news',
  'Asia':        'Asian markets — Nikkei, Hang Seng, Shanghai, KOSPI and regional news',
  'Europe':      'European indices — FTSE, DAX, CAC 40 and EU economic updates',
  'Commodities': 'Gold, silver, crude oil, natural gas and key commodity prices',
};

export const NAV_DESCRIPTIONS = {
  'Watchlist':       'Your personal list of tracked stocks with live prices',
  'Global':          'Global market indices, commodities and currencies across US, Asia and Europe',
  'Domestic':        'NSE indices, sector performance and Indian market news',
  'Extremes':        'Companies with the most positive and most negative news sentiment — '
                   + 'by single day, or cumulatively over a week to a quarter',
  'Mutual Funds':    'Browse and compare mutual fund schemes across categories',
  'Upcoming Events': 'Scheduled macro events — RBI policy, earnings seasons, key economic data',
  'Calendar':        'NSE corporate event calendar — board meetings, results and dividends',
  'Login':           'Sign in to your Niveshflow account',
  'Logout':          'Sign out of your Niveshflow account',
};

export const LOGIN_DESCRIPTIONS = {
  'tab.login':           'Sign in with your existing Niveshflow account',
  'tab.signup':          'Create a new Niveshflow account',
  'field.identifier':    'You can log in using your username, registered email address, or phone number',
  'field.password':      'Your account password — case sensitive',
  'field.username':      'Your unique login handle — only letters, numbers and underscores',
  'field.name':          'Your display name shown inside the app',
  'field.email':         'Used for account recovery and notifications',
  'field.phone':         'Optional — can also be used to log in instead of username or email',
  'field.newPassword':   'Min 8 characters · at least 1 uppercase · 1 number · 1 special character (@$!%*?&)',
  'link.forgotPassword': 'Reset your password via your registered email',
};

export const WATCHLIST_DESCRIPTIONS = {
  'btn.refresh':    'Refresh prices and data for all companies in this watchlist',
  'btn.importCsv':  'Bulk-add companies by uploading a CSV file with NSE symbols',
  'btn.addCompany': 'Search and add a company to this watchlist',
  'btn.addFull':    'Watchlist is full — remove a company to add more',
  'btn.newList':    'Create a new watchlist to organise companies by theme or strategy',
  'col.symbol':     'NSE ticker symbol — click to sort',
  'col.company':    'Full registered company name — click to sort',
  // The two sentiment columns describe different things and will often disagree. Saying so here is
  // what stops a reader treating the pair as a contradiction rather than as the contrast it is:
  // the newest headline against the backdrop it landed against.
  'col.sentimentLatest':  'Sentiment of the single most recent news article for this company — '
                        + 'not an average. It may be from today or from months ago; hover the '
                        + 'badge to see its date.',
  // "Overall" is the column header, so the tooltip has to carry the boundary the header no longer
  // states — without it the column reads as all-time rather than as a rolling quarter.
  'col.sentimentQuarter': 'Average sentiment across every news article from the last 90 days — '
                        + 'a rolling quarter, not all time. Hover the badge to see how many '
                        + 'articles it covers.',
};

export const COMPANY_DESCRIPTIONS = {
  'pe': 'Price-to-Earnings ratio — what you pay per ₹1 of company earnings. Lower = cheaper relative to peers.',
};
